import PageHeader from '../../components/PageHeader';
import StoreHoursCard from './StoreHoursCard';
import DeliverySlotsCard from './DeliverySlotsCard';
import EmergencyCloseCard from './EmergencyCloseCard';

export default function StoreSettings() {
  return (
    <div>
      <PageHeader
        eyebrow="Configuration"
        title="Store Settings"
        subtitle="Control when the storefront is open for new orders."
      />
      <StoreHoursCard />
      <DeliverySlotsCard />
      <EmergencyCloseCard />
    </div>
  );
}
